export const getFlagEmoji = (countryCode: string): string =>
  String.fromCodePoint(
    ...[...countryCode.toUpperCase()].map((char) => 0x1f1e6 + char.charCodeAt(0) - 65),
  );
